import { Stepper, StepperProps } from '@mantine/core';
import React from 'react';

import { useStoreListingWizard } from '../hooks';
import { StepId } from '../types';

export function StepperNavigation() {
  const { contextData, steps, currentStep, skipToStep } =
    useStoreListingWizard();

  const stepIds = Object.keys(steps) as StepId[];

  return (
    <Stepper
      orientation="vertical"
      styles={stepperStyles}
      active={stepIds.findIndex((stepId) => stepId === currentStep.id)}
      onStepClick={(stepIndex) => skipToStep(stepIds[stepIndex])}
    >
      <Stepper.Step
        allowStepSelect={false}
        label={
          contextData.intent === 'create'
            ? 'Choose Product'
            : 'Product Information'
        }
      />
      <Stepper.Step allowStepSelect={false} label="Payment Settings" />
    </Stepper>
  );
}

const stepperStyles: StepperProps['styles'] = (theme) => {
  return {
    step: {
      position: 'relative',
      width: '100%',
      paddingLeft: 4,
      paddingTop: 4,
      cursor: 'default !important',

      '&:not(:first-of-type)': {
        marginTop: -4,
      },

      '&[data-progress]': {
        ':before': {
          content: '""',
          zIndex: -1,
          position: 'absolute',
          top: 1,
          left: 0,
          display: 'block',
          width: '100%',
          height: 41,
          borderRadius: theme.radius.xl,
          backgroundColor: theme.fn.rgba(theme.colors.blue[0], 0.5),
        },
      },
    },
    stepBody: {
      marginTop: theme.spacing.sm,
    },
    verticalSeparator: {
      marginTop: -4,
    },
  };
};
